import { IconCalendarEvent } from "@tabler/icons-react";
import dayjs, { type Dayjs } from "dayjs";
import { classNames } from "src/core/utilities/classNames";

type DateFormat = "DEFAULT" | "SHORT" | "LONG";

interface Props {
    date: string | number | Date | Dayjs;

    /** Defaults to DD-MM-YYYY */
    format?: DateFormat | string;

    includeTime?: boolean;

    icon?: boolean;

    className?: string;
}

const getFormat = (format?: DateFormat | string, includeTime?: boolean) => {
    let outputFormat = format;

    switch (format) {
        case "DEFAULT":
            outputFormat = "DD-MM-YYYY";
            break;

        case "SHORT":
            outputFormat = "ddd D MMM YYYY";
            break;

        case "LONG":
            outputFormat = "dddd D MMMM YYYY";
            break;
    }

    if (includeTime) {
        outputFormat += " [•] HH:mm";
    }

    return outputFormat;
};

export const DateDisplay = ({ date, icon, format = "DEFAULT", includeTime, className }: Props) => {
    const dateObj = dayjs(date);

    return (
        <span className={classNames("inline-flex items-center gap-1", className)}>
            {icon && <IconCalendarEvent className="inline" size={15} />}

            <time dateTime={dateObj.toISOString()}>{dateObj.format(getFormat(format, includeTime))}</time>
        </span>
    );
};
